var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "common" },
    [
      _c("div", { staticClass: "comment-title" }, [_vm._v(_vm._s(_vm.title))]),
      _vm._v(" "),
      _c(
        "div",
        _vm._l(_vm.list, function(val, key) {
          return _c("div", { key: key, staticClass: "list flex-center" }, [
            _c("img", {
              staticClass: "icon",
              attrs: { src: _vm.setAvatar(val.userIcon), alt: "" },
              on: {
                click: function($event) {
                  return _vm.showUserCard(val)
                }
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "flex1 main" }, [
              _c("div", { staticClass: "flex-center" }, [
                _c("div", { staticClass: "flex-center" }, [
                  val.nameplateUrl
                    ? _c("img", {
                        staticClass: "nameplate",
                        attrs: { src: val.nameplateUrl }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  val.wealthlEvel > 0
                    ? _c("div", {
                        staticClass: "bg-grade bg-wealth",
                        class: "wealth" + val.wealthlEvel
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticClass: "title ellipsis",
                      class: { two: val.nameplateUrl }
                    },
                    [_vm._v(_vm._s(val.userName))]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flex1" }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "praise flex-center",
                    class: { active: val.hasLike },
                    on: {
                      click: function($event) {
                        return _vm.toPraise(val, key)
                      }
                    }
                  },
                  [
                    _c("p", { staticClass: "num" }, [
                      _vm._v(_vm._s(val.likeCount))
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "bg",
                      class: { animate: val.showAnimate }
                    })
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "time-list flex-center" }, [
                _c("div", { staticClass: "time" }, [
                  _vm._v(_vm._s(_vm.timeFormate(val.createAt)))
                ]),
                _vm._v(" "),
                _vm.isAdmin || val.showDel
                  ? _c(
                      "div",
                      {
                        staticClass: "del",
                        on: {
                          click: function($event) {
                            return _vm.del(val, key)
                          }
                        }
                      },
                      [_c("span", [_vm._v("·")]), _vm._v("删除")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                val.isTop
                  ? _c("div", { staticClass: "set-top" }, [_vm._v("置顶")])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "reply",
                    on: {
                      click: function($event) {
                        return _vm.replyComment(val)
                      }
                    }
                  },
                  [_vm._v("回复")]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "content",
                  on: {
                    click: function($event) {
                      return _vm.toDetails(val)
                    }
                  }
                },
                [_vm._v("\n          " + _vm._s(val.content) + "\n        ")]
              ),
              _vm._v(" "),
              val.commentCount
                ? _c(
                    "div",
                    {
                      staticClass: "second-comment",
                      on: {
                        click: function($event) {
                          return _vm.toDetails(val)
                        }
                      }
                    },
                    [
                      _vm._l(val.childComment, function(val2, key2) {
                        return _c("div", { key: key2 }, [
                          _c(
                            "div",
                            { staticClass: "main-content" },
                            [
                              val2.toUserName
                                ? [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          val2.isMySelf ? "我" : val2.userName
                                        )
                                      )
                                    ]),
                                    _c("span", { staticClass: "span2" }, [
                                      _vm._v("回复")
                                    ]),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentUserName ===
                                            val2.toUserName
                                            ? "我："
                                            : val2.toUserName + ":"
                                        )
                                      )
                                    ])
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              !val2.toUserName
                                ? [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          val2.isMySelf ? "我" : val2.userName
                                        ) + ": "
                                      )
                                    ])
                                  ]
                                : _vm._e(),
                              _vm._v(
                                "\n              " +
                                  _vm._s(val2.content) +
                                  "\n            "
                              )
                            ],
                            2
                          )
                        ])
                      }),
                      _vm._v(" "),
                      _c("p", { staticClass: "more" }, [
                        _vm._v("共有" + _vm._s(val.commentCount) + "条回复 >")
                      ])
                    ],
                    2
                  )
                : _vm._e()
            ])
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c("loading", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.canLoad,
            expression: "!canLoad"
          }
        ],
        attrs: { isCenter: true }
      }),
      _vm._v(" "),
      _c(
        "p",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.pageOver,
              expression: "pageOver"
            }
          ],
          staticClass: "no-more-data"
        },
        [_vm._v("到底了~")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }